import { PhotosTab } from "./photos-tab";

import type { FC } from "react";

export const UnsplashTab: FC<{
  onImageClick?: (imageUrl: string) => void;
  selectedImage: string | null;
  onSelectionChange?: (hasSelection: boolean) => void;
  hidden?: boolean;
}> = (props) => <PhotosTab endpoint="/photos/stock" placeholder="Search Unsplash" {...props} />;
